module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "userInfo",
    attrs: {
      "lg12": ""
    }
  }, [_vm._l((_vm.objQuoteHistory), function(history) {
    return _c('div', {
      staticClass: "historyBox"
    }, [_c('table', {
      attrs: {
        "width": "100%"
      }
    }, [_c('tr', [_c('td', [_c('strong', [_vm._v("NEW STATUS:")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(history.new_value))])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("PREVIOUS STATUS:")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(history.prev_value))])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("DATE CHANGED:")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(history.timestamp))])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("CHANGED BY:")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(history.name) + " " + _vm._s(history.surname))])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("COMMENTS:")])]), _vm._v(" "), (history.showEdit == true) ? _c('td', [(history.is_customer_reject == 1) ? _c('v-select', {
      staticClass: "dropdown dashDroprep",
      attrs: {
        "items": _vm.rejectReasons,
        "item-value": "id",
        "item-text": "name",
        "autocomplete": "",
        "solo": "",
        "single-line": ""
      },
      model: {
        value: (history.data),
        callback: function($$v) {
          _vm.$set(history, "data", $$v)
        },
        expression: "history.data"
      }
    }) : _vm._e(), _vm._v(" "), (history.is_customer_reject == 0) ? _c('v-text-field', {
      staticStyle: {
        "margin-top": "10px"
      },
      attrs: {
        "label": "Update Comment",
        "multiLine": "",
        "solo": ""
      },
      model: {
        value: (history.data),
        callback: function($$v) {
          _vm.$set(history, "data", $$v)
        },
        expression: "history.data"
      }
    }) : _vm._e(), _vm._v(" "), _c('v-btn', {
      staticClass: "text-xs-right success",
      staticStyle: {
        "margin-left": "1px"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.fncEditReason(history)
        }
      }
    }, [_vm._v("Update")]), _vm._v(" "), _c('v-btn', {
      staticClass: "text-xs-right cancelButton",
      staticStyle: {
        "margin-left": "1px"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.fncEditReason(history)
        }
      }
    }, [_vm._v("Cancel")])], 1) : _c('td', [_vm._v(_vm._s(_vm.fncCheckComment(history.data)))])]), _vm._v(" "), (history.showEdit == false && _vm.fncCanEditComment(history) == true) ? _c('tr', [_c('td', {
      attrs: {
        "width": "30%"
      }
    }), _vm._v(" "), _c('td', [_c('v-btn', {
      staticClass: "text-xs-right success",
      staticStyle: {
        "margin-left": "1px !important"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.fncShowReasonEdit(history)
        }
      }
    }, [_vm._v("Edit Comment")])], 1)]) : _vm._e()])])
  }), _vm._v(" "), (Object.keys(_vm.objQuoteHistory).length === 0) ? _c('p', [_vm._v("There are no status changes recorded for this entry.")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-4 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1)])], 1)], 1)
},staticRenderFns: []}